(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["organism-faq"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  initializeSmoothScroll();
  initializeAccordion();
});

function initializeSmoothScroll() {
  const anchorLinks = document.querySelectorAll('a[href^="#"]');
  anchorLinks.forEach(link => {
    link.addEventListener('click', event => {
      event.preventDefault();
      const targetSelector = link.getAttribute('href');
      const targetElement = document.querySelector(targetSelector);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });
}

function initializeAccordion() {
  const questions = document.querySelectorAll('.faq-question');
  questions.forEach(question => {
    question.addEventListener('click', () => {
      toggleAnswer(question);
    });
  });
}

/**
 * Exibe/esconde a resposta e gira a seta do item de FAQ clicado.
 * @param {HTMLElement} question - Elemento .faq-question que foi clicado.
 */
function toggleAnswer(question) {
  question.classList.toggle('active');

  const answer = question.querySelector('.faq-answer');
  if (answer) {
    answer.classList.toggle('hidden');
  }

  const arrow = question.querySelector('.faq-question-toggle');
  if (arrow) {
    arrow.classList.toggle('rotate-180');
  }
}

  } catch(e) { console.error(e); }
})();
})();
